const countries = [
    { name: 'France', iso: 'FR', phonePrefix: '+33' },
    { name: 'Espagne', iso: 'ES', phonePrefix: '+34' },
    { name: 'Italie', iso: 'IT', phonePrefix: '+39' },
    { name: 'Suisse', iso: 'CH', phonePrefix: '+41' },
    { name: 'Belgique', iso: 'BE', phonePrefix: '+32' },
    { name: 'Afghanistan', iso: 'AF', phonePrefix: '+93' },
    { name: 'Albanie', iso: 'AL', phonePrefix: '+355' },
    { name: 'Algérie', iso: 'DZ', phonePrefix: '+213' },
    { name: 'Andorre', iso: 'AD', phonePrefix: '+376' },
    { name: 'Angola', iso: 'AO', phonePrefix: '+244' },
    { name: 'Antigua-et-Barbuda', iso: 'AG', phonePrefix: '+1-268' },
    { name: 'Argentine', iso: 'AR', phonePrefix: '+54' },
    { name: 'Arménie', iso: 'AM', phonePrefix: '+374' },
    { name: 'Australie', iso: 'AU', phonePrefix: '+61' },
    { name: 'Autriche', iso: 'AT', phonePrefix: '+43' },
    { name: 'Azerbaïdjan', iso: 'AZ', phonePrefix: '+994' },
    { name: 'Bahamas', iso: 'BS', phonePrefix: '+1-242' },
    { name: 'Bahreïn', iso: 'BH', phonePrefix: '+973' },
    { name: 'Bangladesh', iso: 'BD', phonePrefix: '+880' },
    { name: 'Barbade', iso: 'BB', phonePrefix: '+1-246' },
    { name: 'Bélarus', iso: 'BY', phonePrefix: '+375' },
    { name: 'Belize', iso: 'BZ', phonePrefix: '+501' },
    { name: 'Bénin', iso: 'BJ', phonePrefix: '+229' },
    { name: 'Bhoutan', iso: 'BT', phonePrefix: '+975' },
    { name: 'Bolivie', iso: 'BO', phonePrefix: '+591' },
    { name: 'Bosnie-Herzégovine', iso: 'BA', phonePrefix: '+387' },
    { name: 'Botswana', iso: 'BW', phonePrefix: '+267' },
    { name: 'Brésil', iso: 'BR', phonePrefix: '+55' },
    { name: 'Brunei', iso: 'BN', phonePrefix: '+673' },
    { name: 'Bulgarie', iso: 'BG', phonePrefix: '+359' },
    { name: 'Burkina Faso', iso: 'BF', phonePrefix: '+226' },
    { name: 'Burundi', iso: 'BI', phonePrefix: '+257' },
    { name: 'Cabo Verde', iso: 'CV', phonePrefix: '+238' },
    { name: 'Cambodge', iso: 'KH', phonePrefix: '+855' },
    { name: 'Cameroun', iso: 'CM', phonePrefix: '+237' },
    { name: 'Canada', iso: 'CA', phonePrefix: '+1' },
    { name: 'République centrafricaine', iso: 'CF', phonePrefix: '+236' },
    { name: 'Tchad', iso: 'TD', phonePrefix: '+235' },
    { name: 'Chili', iso: 'CL', phonePrefix: '+56' },
    { name: 'Chine', iso: 'CN', phonePrefix: '+86' },
    { name: 'Colombie', iso: 'CO', phonePrefix: '+57' },
    { name: 'Comores', iso: 'KM', phonePrefix: '+269' },
    { name: 'République démocratique du Congo', iso: 'CD', phonePrefix: '+243' },
    { name: 'République du Congo', iso: 'CG', phonePrefix: '+242' },
    { name: 'Costa Rica', iso: 'CR', phonePrefix: '+506' },
    { name: 'Croatie', iso: 'HR', phonePrefix: '+385' },
    { name: 'Cuba', iso: 'CU', phonePrefix: '+53' },
    { name: 'Chypre', iso: 'CY', phonePrefix: '+357' },
    { name: 'République tchèque', iso: 'CZ', phonePrefix: '+420' },
    { name: 'Danemark', iso: 'DK', phonePrefix: '+45' },
    { name: 'Djibouti', iso: 'DJ', phonePrefix: '+253' },
    { name: 'Dominique', iso: 'DM', phonePrefix: '+1-767' },
    { name: 'République dominicaine', iso: 'DO', phonePrefix: '+1-809' },
    { name: 'Équateur', iso: 'EC', phonePrefix: '+593' },
    { name: 'Égypte', iso: 'EG', phonePrefix: '+20' },
    { name: 'El Salvador', iso: 'SV', phonePrefix: '+503' },
    { name: 'Guinée équatoriale', iso: 'GQ', phonePrefix: '+240' },
    { name: 'Érythrée', iso: 'ER', phonePrefix: '+291' },
    { name: 'Estonie', iso: 'EE', phonePrefix: '+372' },
    { name: 'Eswatini', iso: 'SZ', phonePrefix: '+268' },
    { name: 'Éthiopie', iso: 'ET', phonePrefix: '+251' },
    { name: 'Fidji', iso: 'FJ', phonePrefix: '+679' },
    { name: 'Finlande', iso: 'FI', phonePrefix: '+358' },
    { name: 'Gabon', iso: 'GA', phonePrefix: '+241' },
    { name: 'Gambie', iso: 'GM', phonePrefix: '+220' },
    { name: 'Géorgie', iso: 'GE', phonePrefix: '+995' },
    { name: 'Allemagne', iso: 'DE', phonePrefix: '+49' },
    { name: 'Ghana', iso: 'GH', phonePrefix: '+233' },
    { name: 'Grèce', iso: 'GR', phonePrefix: '+30' },
    { name: 'Grenade', iso: 'GD', phonePrefix: '+1-473' },
    { name: 'Guatemala', iso: 'GT', phonePrefix: '+502' },
    { name: 'Guinée', iso: 'GN', phonePrefix: '+224' },
    { name: 'Guinée-Bissau', iso: 'GW', phonePrefix: '+245' },
    { name: 'Guyana', iso: 'GY', phonePrefix: '+592' },
    { name: 'Haïti', iso: 'HT', phonePrefix: '+509' },
    { name: 'Honduras', iso: 'HN', phonePrefix: '+504' },
    { name: 'Hongrie', iso: 'HU', phonePrefix: '+36' },
    { name: 'Islande', iso: 'IS', phonePrefix: '+354' },
    { name: 'Inde', iso: 'IN', phonePrefix: '+91' },
    { name: 'Indonésie', iso: 'ID', phonePrefix: '+62' },
    { name: 'Iran', iso: 'IR', phonePrefix: '+98' },
    { name: 'Irak', iso: 'IQ', phonePrefix: '+964' },
    { name: 'Irlande', iso: 'IE', phonePrefix: '+353' },
    { name: 'Israël', iso: 'IL', phonePrefix: '+972' },
    { name: 'Jamaïque', iso: 'JM', phonePrefix: '+1-876' },
    { name: 'Japon', iso: 'JP', phonePrefix: '+81' },
    { name: 'Jordanie', iso: 'JO', phonePrefix: '+962' },
    { name: 'Kazakhstan', iso: 'KZ', phonePrefix: '+7' },
    { name: 'Kenya', iso: 'KE', phonePrefix: '+254' },
    { name: 'Kiribati', iso: 'KI', phonePrefix: '+686' },
    { name: 'Corée du Nord', iso: 'KP', phonePrefix: '+850' },
    { name: 'Corée du Sud', iso: 'KR', phonePrefix: '+82' },
    { name: 'Kosovo', iso: 'XK', phonePrefix: '+383' },
    { name: 'Koweït', iso: 'KW', phonePrefix: '+965' },
    { name: 'Kirghizistan', iso: 'KG', phonePrefix: '+996' },
    { name: 'Laos', iso: 'LA', phonePrefix: '+856' },
    { name: 'Lettonie', iso: 'LV', phonePrefix: '+371' },
    { name: 'Liban', iso: 'LB', phonePrefix: '+961' },
    { name: 'Lesotho', iso: 'LS', phonePrefix: '+266' },
    { name: 'Libéria', iso: 'LR', phonePrefix: '+231' },
    { name: 'Libye', iso: 'LY', phonePrefix: '+218' },
    { name: 'Liechtenstein', iso: 'LI', phonePrefix: '+423' },
    { name: 'Lituanie', iso: 'LT', phonePrefix: '+370' },
    { name: 'Luxembourg', iso: 'LU', phonePrefix: '+352' },
    { name: 'Madagascar', iso: 'MG', phonePrefix: '+261' },
    { name: 'Malawi', iso: 'MW', phonePrefix: '+265' },
    { name: 'Malaisie', iso: 'MY', phonePrefix: '+60' },
    { name: 'Maldives', iso: 'MV', phonePrefix: '+960' },
    { name: 'Mali', iso: 'ML', phonePrefix: '+223' },
    { name: 'Malte', iso: 'MT', phonePrefix: '+356' },
    { name: 'Îles Marshall', iso: 'MH', phonePrefix: '+692' },
    { name: 'Mauritanie', iso: 'MR', phonePrefix: '+222' },
    { name: 'Maurice', iso: 'MU', phonePrefix: '+230' },
    { name: 'Mexique', iso: 'MX', phonePrefix: '+52' },
    { name: 'Micronésie', iso: 'FM', phonePrefix: '+691' },
    { name: 'Moldavie', iso: 'MD', phonePrefix: '+373' },
    { name: 'Monaco', iso: 'MC', phonePrefix: '+377' },
    { name: 'Mongolie', iso: 'MN', phonePrefix: '+976' },
    { name: 'Monténégro', iso: 'ME', phonePrefix: '+382' },
    { name: 'Maroc', iso: 'MA', phonePrefix: '+212' },
    { name: 'Mozambique', iso: 'MZ', phonePrefix: '+258' },
    { name: 'Myanmar', iso: 'MM', phonePrefix: '+95' },
    { name: 'Namibie', iso: 'NA', phonePrefix: '+264' },
    { name: 'Nauru', iso: 'NR', phonePrefix: '+674' },
    { name: 'Népal', iso: 'NP', phonePrefix: '+977' },
    { name: 'Pays-Bas', iso: 'NL', phonePrefix: '+31' },
    { name: 'Nouvelle-Zélande', iso: 'NZ', phonePrefix: '+64' },
    { name: 'Nicaragua', iso: 'NI', phonePrefix: '+505' },
    { name: 'Niger', iso: 'NE', phonePrefix: '+227' },
    { name: 'Nigéria', iso: 'NG', phonePrefix: '+234' },
    { name: 'Macédoine du Nord', iso: 'MK', phonePrefix: '+389' },
    { name: 'Norvège', iso: 'NO', phonePrefix: '+47' },
    { name: 'Oman', iso: 'OM', phonePrefix: '+968' },
    { name: 'Pakistan', iso: 'PK', phonePrefix: '+92' },
    { name: 'Palaos', iso: 'PW', phonePrefix: '+680' },
    { name: 'Panama', iso: 'PA', phonePrefix: '+507' },
    { name: 'Papouasie-Nouvelle-Guinée', iso: 'PG', phonePrefix: '+675' },
    { name: 'Paraguay', iso: 'PY', phonePrefix: '+595' },
    { name: 'Pérou', iso: 'PE', phonePrefix: '+51' },
    { name: 'Philippines', iso: 'PH', phonePrefix: '+63' },
    { name: 'Pologne', iso: 'PL', phonePrefix: '+48' },
    { name: 'Portugal', iso: 'PT', phonePrefix: '+351' },
    { name: 'Qatar', iso: 'QA', phonePrefix: '+974' },
    { name: 'Roumanie', iso: 'RO', phonePrefix: '+40' },
    { name: 'Russie', iso: 'RU', phonePrefix: '+7' },
    { name: 'Rwanda', iso: 'RW', phonePrefix: '+250' },
    { name: 'Saint-Christophe-et-Niévès', iso: 'KN', phonePrefix: '+1-869' },
    { name: 'Sainte-Lucie', iso: 'LC', phonePrefix: '+1-758' },
    { name: 'Saint-Vincent-et-les-Grenadines', iso: 'VC', phonePrefix: '+1-784' },
    { name: 'Samoa', iso: 'WS', phonePrefix: '+685' },
    { name: 'Saint-Marin', iso: 'SM', phonePrefix: '+378' },
    { name: 'Sao Tomé-et-Principe', iso: 'ST', phonePrefix: '+239' },
    { name: 'Arabie saoudite', iso: 'SA', phonePrefix: '+966' },
    { name: 'Sénégal', iso: 'SN', phonePrefix: '+221' },
    { name: 'Serbie', iso: 'RS', phonePrefix: '+381' },
    { name: 'Seychelles', iso: 'SC', phonePrefix: '+248' },
    { name: 'Sierra Leone', iso: 'SL', phonePrefix: '+232' },
    { name: 'Singapour', iso: 'SG', phonePrefix: '+65' },
    { name: 'Slovaquie', iso: 'SK', phonePrefix: '+421' },
    { name: 'Slovénie', iso: 'SI', phonePrefix: '+386' },
    { name: 'Îles Salomon', iso: 'SB', phonePrefix: '+677' },
    { name: 'Somalie', iso: 'SO', phonePrefix: '+252' },
    { name: 'Afrique du Sud', iso: 'ZA', phonePrefix: '+27' },
    { name: 'Soudan du Sud', iso: 'SS', phonePrefix: '+211' },
    { name: 'Sri Lanka', iso: 'LK', phonePrefix: '+94' },
    { name: 'Soudan', iso: 'SD', phonePrefix: '+249' },
    { name: 'Suriname', iso: 'SR', phonePrefix: '+597' },
    { name: 'Suède', iso: 'SE', phonePrefix: '+46' },
    { name: 'Syrie', iso: 'SY', phonePrefix: '+963' },
    { name: 'Taïwan', iso: 'TW', phonePrefix: '+886' },
    { name: 'Tadjikistan', iso: 'TJ', phonePrefix: '+992' },
    { name: 'Tanzanie', iso: 'TZ', phonePrefix: '+255' },
    { name: 'Thaïlande', iso: 'TH', phonePrefix: '+66' },
    { name: 'Timor oriental', iso: 'TL', phonePrefix: '+670' },
    { name: 'Togo', iso: 'TG', phonePrefix: '+228' },
    { name: 'Tonga', iso: 'TO', phonePrefix: '+676' },
    { name: 'Trinité-et-Tobago', iso: 'TT', phonePrefix: '+1-868' },
    { name: 'Tunisie', iso: 'TN', phonePrefix: '+216' },
    { name: 'Turquie', iso: 'TR', phonePrefix: '+90' },
    { name: 'Turkménistan', iso: 'TM', phonePrefix: '+993' },
    { name: 'Tuvalu', iso: 'TV', phonePrefix: '+688' },
    { name: 'Ouganda', iso: 'UG', phonePrefix: '+256' },
    { name: 'Ukraine', iso: 'UA', phonePrefix: '+380' },
    { name: 'Émirats arabes unis', iso: 'AE', phonePrefix: '+971' },
    { name: 'Royaume-Uni', iso: 'GB', phonePrefix: '+44' },
    { name: 'États-Unis', iso: 'US', phonePrefix: '+1' },
    { name: 'Uruguay', iso: 'UY', phonePrefix: '+598' },
    { name: 'Ouzbékistan', iso: 'UZ', phonePrefix: '+998' },
    { name: 'Vanuatu', iso: 'VU', phonePrefix: '+678' },
    { name: 'Venezuela', iso: 'VE', phonePrefix: '+58' },
    { name: 'Vietnam', iso: 'VN', phonePrefix: '+84' },
    { name: 'Yémen', iso: 'YE', phonePrefix: '+967' },
    { name: 'Zambie', iso: 'ZM', phonePrefix: '+260' },
    { name: 'Zimbabwe', iso: 'ZW', phonePrefix: '+263' },
    { name: "Saint Barthélemy", iso: "BL", phonePrefix: "+590" },
    { name: "Saint-Martin", iso: "MF", phonePrefix: "+590" },
    { name: "Saint-Pierre-et-Miquelon", iso: "PM", phonePrefix: "+508" },
    { name: "Wallis et Futuna", iso: "WF", phonePrefix: "+681" },
    { name: "Mayotte", iso: "YT", phonePrefix: "+262" },
    { name: "Nouvelle-Calédonie", iso: "NC", phonePrefix: "+687" },
    { name : "Martinique", iso: "MQ", phonePrefix: "+596" },
    { name : "Guyane", iso: "GF", phonePrefix: "+594" },
    { name : "Guadeloupe", iso: "GP", phonePrefix: "+590" },
    { name : "Réunion", iso: "RE", phonePrefix: "+262" },
    
];

export const getCountryByIso = (iso) => countries.find(country => country.iso === iso);

export const getCountryByName = (name) => countries.find(country => country.name === name);

export const getCountries = () => countries;

export const getCountryOptions = () => countries.map(country => country.name);

export const getCountryIsoOptions = () => countries.map(country => country.iso);

export const getCountryPhonePrefixOptions = () => countries.map(country => country.phonePrefix);
